module.exports = __webpack_public_path__ + "static/media/help.455f2fef.svg";